import { Navigate } from 'react-router-dom';
import useAuth from './useAuth';

export default function PublicRoute({ children }) {
  const { token, user, isLoadingUser } = useAuth();

  // wait until user is resolved
  if (isLoadingUser) return null; // or loader

  if (token && user) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
